import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { setApprovalHistoryReportFilters } from 'Store/OrderManagement/ApprovalHistoryReport/ApprovalHistoryReportAction';
import { setComplianceReportFilterData } from "Store/OrderManagement/ComplainceReport/ComplainceReportAction";

const useLocationDropDowns = (args: any) => {

    const { 
        regionDropDown,
        marketDropDown,
        costCenterByMarketDropDownList,
        getMarketDropDown,
        getCostCenterByMarket,
        approvalHistoryReportFilters,
        complianceReportFilterData,
        isApprovalHistory
    } = args

  const dispatch = useDispatch() 
  const [regionDropDownList, setRegionDropDownList] = useState<any>([])
  const [marketDropDownList, setMarketDropDownList] = useState<any>([])
  const [costCentersByMarketList, setCostCentersByMarketList] = useState([]);

  useEffect(() => {
    if (regionDropDown?.length) {
      const regionDropDownTemp = regionDropDown?.map((item: any) =>
        ({ label: item.text, key: item.value, ...item })
      );
      setRegionDropDownList(regionDropDownTemp);
      if(regionDropDownTemp?.length == 1){
        dispatch(getMarketDropDown(regionDropDownTemp[0]?.key))
        if(isApprovalHistory){
        dispatch(setApprovalHistoryReportFilters({...approvalHistoryReportFilters, region: regionDropDownTemp[0]}))
        } else{ 
          dispatch(setComplianceReportFilterData({...complianceReportFilterData, region: regionDropDownTemp[0]}))
        }
      }
    }
  }, [regionDropDown])
  
  useEffect(() => {
    if (marketDropDown?.length) {
      const marketDropDownTemp = marketDropDown?.map((item: any) =>
        ({ label: item.text, key: item.value, ...item })
      );
      setMarketDropDownList(marketDropDownTemp);
      if(marketDropDownTemp?.length == 1){
        dispatch(getCostCenterByMarket({marketId : marketDropDownTemp[0]?.key},true))
        if(isApprovalHistory){
        dispatch(setApprovalHistoryReportFilters({...approvalHistoryReportFilters, market: marketDropDownTemp[0]}))
        }else{
          dispatch(setComplianceReportFilterData({...complianceReportFilterData, market: marketDropDownTemp[0]}))
        }
      }
    }
  }, [marketDropDown])
  
  useEffect(() => {
    if (costCenterByMarketDropDownList?.length) {
      const costCenterDropdownListTemp = costCenterByMarketDropDownList?.map((item: any, _index: number) => ({ ...item, label: item?.text }));
      setCostCentersByMarketList(costCenterDropdownListTemp);
      if(costCenterDropdownListTemp?.length == 1){
        if(isApprovalHistory){
        dispatch(setApprovalHistoryReportFilters({...approvalHistoryReportFilters, costCenter: costCenterDropdownListTemp[0]}))
        } else{
          dispatch(setComplianceReportFilterData({...complianceReportFilterData, costCenter: costCenterDropdownListTemp[0]}))
        }
      }
    }
  }, [costCenterByMarketDropDownList])

  return [regionDropDownList, marketDropDownList, costCentersByMarketList];
};

export default useLocationDropDowns;